import React from "react";
import { cn } from "@/lib/cn";

export interface IconButtonProps extends Omit<React.ButtonHTMLAttributes<HTMLButtonElement>, "aria-label"> {
  /** Required accessible name — icon-only buttons are invisible to AT without it. */
  label: string;
  size?: "sm" | "md";
}

export const IconButton = React.forwardRef<HTMLButtonElement, IconButtonProps>(
  function IconButton({ label, size = "md", className, type = "button", ...rest }, ref) {
    return (
      <button
        ref={ref}
        type={type}
        aria-label={label}
        className={cn(
          "inline-flex items-center justify-center rounded-md text-ink-secondary",
          "transition-colors cursor-pointer hover:bg-hover disabled:opacity-50",
          "focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-accent",
          size === "sm" ? "h-7 w-7" : "h-9 w-9",
          className,
        )}
        {...rest}
      />
    );
  },
);
